/** @jsxImportSource react */
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { useMyTenants } from '../hooks/useCrmQueries'
import { selectTenant } from '../store/slices/tenantSlice'
import Loading from '../components/common/Loading'

/**
 * Where a push notification opens: /open?to=<in-app path>&ws=<workspace id>. Switches to that
 * workspace first when it's another one the person belongs to, then goes to the page.
 */
const OpenLinkPage = () => {
  const [params] = useSearchParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const current = useSelector((state) => state.tenant.current)
  const { data: tenants, isError } = useMyTenants()
  const to = params.get('to') || '/'
  const target = to.startsWith('/') && !to.startsWith('//') ? to : '/'   // only paths inside the app
  const ws = params.get('ws')

  useEffect(() => {
    if (!tenants && !isError) return
    if (ws && current?.tenantId !== ws) {
      const t = (tenants || []).find((x) => x.tenantId === ws && x.status === 'ACTIVE')
      if (t) {
        dispatch(selectTenant(t))
        queryClient.removeQueries({ predicate: (q) => q.queryKey[0] !== 'me' })
      }
    }
    navigate(target, { replace: true })
  }, [tenants, isError, ws, current, target, dispatch, navigate, queryClient])

  if (!ws) return <Navigate to={target} replace />
  return <Loading />
}

export default OpenLinkPage
